"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var showExitAlert = function (event) {
    event.returnValue = '';
};
exports.WithCloseTabEvent = function (_a) {
    var children = _a.children;
    react_1.useEffect(function () {
        window.addEventListener('beforeunload', showExitAlert);
        return function () {
            window.removeEventListener('beforeunload', showExitAlert);
        };
    }, []);
    return react_1.default.createElement(react_1.default.Fragment, null, children);
};
//# sourceMappingURL=WithCloseTabEvent.js.map